import * as PhoneActions from './phone.actions';

export { PhoneActions };
